import '../css/xszn.scss'
import "./components/anchorTo.js"

var app = {
  init:function() {
    this.bindEvent()
  },
  bindEvent: function(){
    this.tab($('.js-tab'))
  },
  tab(el) {
    var _nav = $('.tab', el);
    var _item = $('.tab-pn-item', el);
    var that = this;
    var isClicked = []
    _nav.tabs(_item, {
      tabs: 'a',
      event: 'click',
      onClick: function(e,i) { 
        if(!isClicked[i]){
          that.slickTab($('.tab-pn-item').eq(i).find('.js-sub-tab'))
          isClicked[i] = true
        }
      }
    });
  },
  slickTab(el) {
    var _nav = el.find('.sub-tab');
    var _item = el.find('.sub-tab-pn');
    _nav.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      draggable: false,
      asNavFor: _item
    });
    _item.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      infinite: false,
      draggable: false,
      asNavFor: _nav
    });
  },
}
app.init()